export const CLASS_LOG_MODULES = [
  { type: 'meditation', label: 'Meditation', shortLabel: 'Med' },
  { type: 'brain_gym', label: 'Brain Gym', shortLabel: 'Gym' },
  { type: 'advance_math', label: 'Advance Math', shortLabel: 'Math' },
  { type: 'brain_stimulation', label: 'Brain Stimulation', shortLabel: 'Stim' },
  { type: 'recalling', label: 'Recalling', shortLabel: 'Recall' },
  { type: 'ndh', label: 'Non Dominating Hand', shortLabel: 'NDH' },
  { type: 'blind_fold', label: 'Blind Fold', shortLabel: 'Blind' },
];

export const CLASS_LOG_MODULE_TYPES = CLASS_LOG_MODULES.map((m) => m.type);
